// src/components/WantAdEditor/index.jsx  (wrapper + code-splitting)
import React, { Suspense, useMemo } from "react";
import { useAppConfig } from "@/appConfig";

export default function CreateWantAdNextEditor(props) {
  const { flags } = useAppConfig();

  const LazyEditor = useMemo(() => {
    return React.lazy(() =>
      flags.mlsAgentEditor
        ? import("./MLSCreateAWantAdNext")
        : import("./CreateAWantAdNext"),
    );
  }, [flags.mlsAgentEditor]);

  return (
    <Suspense fallback={null}>
      <LazyEditor {...props} />
    </Suspense>
  );
}
